var url = "";
if (window.location.host === "kuwait-qrcode.starcinemas.com") {
  url = "https://kuwait-cron-api.starcinemas.com";
} else {
  // url = 'http://localhost:3800'
  url = "https://kuwait-cron-api.starcinemas.com";
}
export const URL_BASE = url;



// WEBPACK FOOTER //
// ./src/helper/constants.js